"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _navMenu = require("../styles/navMenu"),
    AdminToggle = function AdminToggle(a) {
  var b = a.adminMode,
      c = a.toggleAdminMode,
      d = a.className;
  return c ? _react["default"].createElement("button", {
    type: "button",
    "data-cy": "toggle-admin-mode-btn",
    className: (0, _classnames["default"])(d, _navMenu.ADMIN_TOGGLE),
    onClick: c
  }, _react["default"].createElement(_Icon["default"], {
    name: "intaccess",
    size: 25,
    color: b ? "white" : "monkey",
    tooltipId: "toggle-admin-tooltip",
    tooltipLabel: "Switch to ".concat(b ? "User" : "Admin", " Mode"),
    tooltipPlace: "bottom"
  })) : null;
},
    _default = AdminToggle;

exports["default"] = _default;